/**
 * Type guard for PromiseSettledResult to check if the promise is rejected.
 * @param input - The promise to check.
 * @returns - True if the promise is rejected, false otherwise.
 */
export const isRejected = (input: PromiseSettledResult<unknown>): input is PromiseRejectedResult =>
  input.status === 'rejected';

/**
 * Type guard for PromiseSettledResult to check if the promise is fulfilled.
 *
 * @param input - The promise to check.
 * @returns - True if the promise is fulfilled, false otherwise.
 */
export const isFulfilled = <T>(
  input: PromiseSettledResult<T>,
): input is PromiseFulfilledResult<T> => input.status === 'fulfilled';

/**
 * Type guard that asserts that the input can never occur.
 *
 * @param x - The input to check.
 */
export const asserNever = (x: never): never => {
  throw new Error(`Unexpected object: ${x}`);
};
